'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TaskListView;

var _preact = require('preact');

var _format = require('../../vendor/format.js');

var _format2 = _interopRequireDefault(_format);

var _fileLink = require('../../containers/fileLink.js');

var _fileLink2 = _interopRequireDefault(_fileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TaskListView(props) {
  var tasks = (props.tasks || []).map(function (task, i) {
    var created_at = _format2.default.verboseDate(task.created_at);
    var files = [];
    var cancel = void 0;
    if (task.content_file) {
      files.push((0, _preact.h)(
        'span',
        { 'class': 'name' },
        (0, _preact.h)(_fileLink2.default, { file: task.content_file })
      ));
    }
    if (task.style_file) {
      files.push((0, _preact.h)(
        'span',
        { 'class': 'name' },
        (0, _preact.h)(_fileLink2.default, { file: task.style_file })
      ));
    }
    if (!task.output_file && !task.processing) {
      cancel = (0, _preact.h)(
        'span',
        { 'class': 'cancel', onClick: function onClick() {
            return props.cancelTask(task);
          } },
        'x'
      );
    }
    var completed = task.completed ? 'completed' : '';
    var filename = task.output_file ? task.output_file.name : task.processing ? '(processing)' : '(waiting)';
    return (0, _preact.h)(
      'div',
      { key: i },
      (0, _preact.h)(
        'div',
        { 'class': 'row' },
        (0, _preact.h)(
          'span',
          { 'class': 'date' },
          created_at.date
        ),
        (0, _preact.h)(
          'span',
          { 'class': 'time' },
          created_at.time
        ),
        (0, _preact.h)(
          'span',
          { 'class': 'name output ' + completed },
          (0, _preact.h)(
            _fileLink2.default,
            { file: task.output_file },
            filename
          )
        ),
        cancel
      ),
      (0, _preact.h)(
        'div',
        { 'class': 'row' },
        (0, _preact.h)(
          'span',
          { 'class': 'alpha' },
          '\u03B1=',
          task.alpha
        ),
        files
      )
    );
    // <span class='name'>{task.result_file.name}</span>
  });
  return (0, _preact.h)(
    'div',
    { 'class': 'tasks list' },
    tasks
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Tasks/TaskListView.jsx
// module id = 112
// module chunks = 0